export default {"src":"/_next/static/media/avatar_m.c6748e06.svg","height":50,"width":50};